// @flow
export default (str : string, num : number) : any => {
  if (str.length > num) {
    return `${str.slice(0, num)} ...`;
  }
  return str;
};
